import { createContext as jt, useContext as vt, useState as V, useEffect as St, useMemo as Et } from "react";
import { jsx as ht } from "react/jsx-runtime";
function Ot(e) {
  const n = jt(e), s = () => {
    const a = vt(n);
    if (a === void 0)
      throw new Error(
        "Context is attempting to be consumed outside of its provider."
      );
    return a;
  };
  return {
    Provider: n.Provider,
    useContext: s
  };
}
var y = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var g = { exports: {} };
g.exports;
var $;
function Tt() {
  return $ || ($ = 1, (function(e, n) {
    var s = 9007199254740991, a = "[object Arguments]", i = "[object Function]", b = "[object GeneratorFunction]", p = "[object Map]", K = "[object Object]", x = "[object Promise]", w = "[object Set]", T = "[object WeakMap]", _ = "[object DataView]", W = /[\\^$.*+?()[\]{}|]/g, H = /^\[object .+?Constructor\]$/, q = typeof y == "object" && y && y.Object === Object && y, J = typeof self == "object" && self && self.Object === Object && self, c = q || J || Function("return this")(), I = n && !n.nodeType && n, P = I && !0 && e && !e.nodeType && e, U = P && P.exports === I;
    function z(t, r) {
      return t?.[r];
    }
    function X(t) {
      var r = !1;
      if (t != null && typeof t.toString != "function")
        try {
          r = !!(t + "");
        } catch {
        }
      return r;
    }
    function Y(t, r) {
      return function(o) {
        return t(r(o));
      };
    }
    var Q = Function.prototype, d = Object.prototype, C = c["__core-js_shared__"], L = (function() {
      var t = /[^.]+$/.exec(C && C.keys && C.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    })(), M = Q.toString, j = d.hasOwnProperty, m = d.toString, Z = RegExp(
      "^" + M.call(j).replace(W, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), k = U ? c.Buffer : void 0, A = d.propertyIsEnumerable, tt = k ? k.isBuffer : void 0, et = Y(Object.keys, Object), v = l(c, "DataView"), S = l(c, "Map"), E = l(c, "Promise"), h = l(c, "Set"), O = l(c, "WeakMap"), rt = !A.call({ valueOf: 1 }, "valueOf"), nt = f(v), ot = f(S), st = f(E), at = f(h), it = f(O);
    function ct(t) {
      return m.call(t);
    }
    function ut(t) {
      if (!F(t) || ft(t))
        return !1;
      var r = N(t) || X(t) ? Z : H;
      return r.test(f(t));
    }
    function l(t, r) {
      var o = z(t, r);
      return ut(o) ? o : void 0;
    }
    var u = ct;
    (v && u(new v(new ArrayBuffer(1))) != _ || S && u(new S()) != p || E && u(E.resolve()) != x || h && u(new h()) != w || O && u(new O()) != T) && (u = function(t) {
      var r = m.call(t), o = r == K ? t.constructor : void 0, G = o ? f(o) : void 0;
      if (G)
        switch (G) {
          case nt:
            return _;
          case ot:
            return p;
          case st:
            return x;
          case at:
            return w;
          case it:
            return T;
        }
      return r;
    });
    function ft(t) {
      return !!L && L in t;
    }
    function pt(t) {
      var r = t && t.constructor, o = typeof r == "function" && r.prototype || d;
      return t === o;
    }
    function f(t) {
      if (t != null) {
        try {
          return M.call(t);
        } catch {
        }
        try {
          return t + "";
        } catch {
        }
      }
      return "";
    }
    function lt(t) {
      return dt(t) && j.call(t, "callee") && (!A.call(t, "callee") || m.call(t) == a);
    }
    var gt = Array.isArray;
    function D(t) {
      return t != null && bt(t.length) && !N(t);
    }
    function dt(t) {
      return wt(t) && D(t);
    }
    var mt = tt || Ct;
    function yt(t) {
      if (D(t) && (gt(t) || typeof t == "string" || typeof t.splice == "function" || mt(t) || lt(t)))
        return !t.length;
      var r = u(t);
      if (r == p || r == w)
        return !t.size;
      if (rt || pt(t))
        return !et(t).length;
      for (var o in t)
        if (j.call(t, o))
          return !1;
      return !0;
    }
    function N(t) {
      var r = F(t) ? m.call(t) : "";
      return r == i || r == b;
    }
    function bt(t) {
      return typeof t == "number" && t > -1 && t % 1 == 0 && t <= s;
    }
    function F(t) {
      var r = typeof t;
      return !!t && (r == "object" || r == "function");
    }
    function wt(t) {
      return !!t && typeof t == "object";
    }
    function Ct() {
      return !1;
    }
    e.exports = yt;
  })(g, g.exports)), g.exports;
}
var _t = Tt();
const It = /* @__PURE__ */ xt(_t);
function Pt(e) {
  return It(e);
}
const Lt = (e, n) => window.localStorage.setItem(e, n), Mt = (e) => window.localStorage.getItem(e), kt = (e) => window.localStorage.removeItem(e), At = {
  setItem: Lt,
  getItem: Mt,
  removeItem: kt
}, Dt = {
  appDataStorageKey: "mage-cache-storage"
};
ENVIRONMENT_REGION;
const R = "private-content-loaded", { appDataStorageKey: Nt } = Dt;
function Ft() {
  return JSON.parse(At.getItem(Nt) || "{}")?.customer || {};
}
const Gt = "@gensler.com";
function Vt(e) {
  return e?.email ? (e?.email?.toLowerCase()?.trim()).endsWith(Gt) : !1;
}
function $t() {
  const [e, n] = V(() => {
    const i = Ft();
    return Pt(i) ? null : B(i);
  }), [s, a] = V(() => e === null);
  return St(() => {
    function i(b) {
      const p = b.detail.data.customer;
      n(B(p)), a(!1);
    }
    return window.addEventListener(R, i), () => {
      window.removeEventListener(
        R,
        i
      );
    };
  }, []), {
    isLoading: s,
    customer: e
  };
}
function B(e) {
  return {
    ...e,
    isGenslerCustomer: Vt(e)
  };
}
const { Provider: Rt, useContext: Wt } = Ot();
function Ht({ children: e }) {
  const { isLoading: n, customer: s } = $t(), a = Et(() => ({
    isLoading: n,
    customer: s
  }), [n, s]);
  return /* @__PURE__ */ ht(Rt, { value: a, children: e });
}
export {
  Ht as CustomerProvider,
  $t as useCustomer,
  Wt as useCustomerProvider
};
